<template>
  <div class="form place-form">
    <div class="field">
      <label for="name" class="label">Nome *</label>
      <div class="control">
        <input
          type="text"
          class="input"
          id="name"
          v-model="fData.name"
          :disabled="disabledFields.name"
        >
      </div>
    </div>
    <div class="field">
      <label class="label">
        <checkbox
          v-model="fData.active"
          :disabled="disabledFields.active"
          :checked="fData.active"
        />
        Ativo *
      </label>
    </div>
    <div class="field">
      <label for="shortdesc" class="label">Descrição Curta *</label>
      <div class="control">
        <textarea
          v-model="fData.shortDescription"
          id="shortdesc"
          maxlength="500"
          rows="10"
          class="textarea"
          :disabled="disabledFields.shortDescription"
        ></textarea>
        <div class="is-pulled-right">
          <char-count
            :countdown="500"
            :data-string="fData.shortDescription"
            suffix="caracteres restantes"
          />
        </div>
      </div>
    </div>
    <div class="field">
      <label for="longdesc" class="label">Descrição Longa *</label>
      <div class="control">
        <textarea
          v-model="fData.longDescription"
          id="longdesc"
          maxlength="1000"
          rows="10"
          class="textarea"
          :disabled="disabledFields.longDescription"
        ></textarea>
        <div class="is-pulled-right">
          <char-count
            :countdown="1000"
            :data-string="fData.longDescription"
            suffix="caracteres restantes"
          />
        </div>
      </div>
    </div>
    <div class="field">
      <label for="informations" class="label">Informações *</label>
      <div class="control">
        <textarea
          v-model="fData.informations"
          id="informations"
          maxlength="1000"
          rows="10"
          class="textarea"
          :disabled="disabledFields.informations"
        ></textarea>
        <div class="is-pulled-right">
          <char-count
            :countdown="1000"
            :data-string="fData.informations"
            suffix="caracteres restantes"
          />
        </div>
      </div>
    </div>
    <div class="field">
      <label for="operation" class="label">Operações</label>
      <div class="control">
        <textarea
          v-model="fData.operation"
          :disabled="disabledFields.operation"
          id="operation"
          maxlength="500"
          rows="10"
          class="textarea"
        ></textarea>
        <div class="is-pulled-right">
          <char-count
            :countdown="500"
            :data-string="fData.operation"
            suffix="caracteres restantes"
          />
        </div>
      </div>
    </div>
    <div class="field">
      <label for="contacts" class="label">Contatos</label>
      <div class="control">
        <textarea
          v-model="fData.contacts"
          id="operation"
          maxlength="400"
          rows="10"
          class="textarea"
          :disabled="disabledFields.contacts"
        ></textarea>
        <div class="is-pulled-right">
          <char-count
            :countdown="400"
            :data-string="fData.contacts"
            suffix="caracteres restantes"
          />
        </div>
      </div>
    </div>
    <div class="field">
      <label for="site" class="label">Site</label>
      <div class="control">
        <input
          type="text"
          class="input"
          maxlength="400"
          id="site"
          v-model="fData.site"
          :disabled="disabledFields.site"
        >
        <div class="is-pulled-right">
          <char-count
            :countdown="400"
            :data-string="fData.site"
            suffix="caracteres restantes"
          />
        </div>
      </div>
    </div>
    <div class="field">
      <label for="addressformated" class="label">Endereço *</label>
      <div class="control has-addons">
        <input
          type="text"
          class="input"
          id="addressformated"
          v-model="fData.addressFormatted"
          style="flex: 1; display: flex"
          :disabled="disabledFields.addressFormatted"
        >
        <button
          class="button"
          :class="{ 'is-loading': isSearchingLocation }"
          :disabled="isSearchingLocation || disabledFields.addressFormatted"
          @click="searchLocation"
        >
          Localizar no mapa
        </button>
      </div>
    </div>
    <div class="field">
      <div class="control is-horizontal">
        <div class="control is-grouped">
          <div class="control is-expanded">
            <label for="latitude" class="label">Latitude *</label>
            <input
              type="text"
              class="input"
              id="latitude"
              v-model="fData.addressLatitude"
              :disabled="disabledFields.addressLatitude"
            >
          </div>
          <div class="control is-expanded">
            <label for="longitude" class="label">Longitude *</label>
            <input
              type="text"
              class="input"
              id="longitude"
              v-model="fData.addressLongitude"
              :disabled="disabledFields.addressLongitude"
            >
          </div>
        </div>
      </div>
    </div>
    <div class="field">
      <label class="label">Mapa</label>
      <div class="control">
        <gmap-map
          :center="{
            lat: fData.addressLatitude,
            lng: fData.addressLongitude
          }"
          :zoom="13"
          style="width: 100%; height: 300px"
          ref="map"
        >
          <gmap-marker
            :position="{
              lat: fData.addressLatitude,
              lng: fData.addressLongitude
            }"
            :draggable="true || !(disabledFields.addressLatitude || disabledFields.addressLongitude)"
            @dragend="getNewLatLng"
          />
        </gmap-map>
      </div>
    </div>
    <div class="field">
      <label for="category" class="label">Categoria *</label>
      <div class="control">
        <div class="select" :class="{ 'is-loading': Categories.length === 0 }">
          <select
            id="category"
            v-model="fData.categoryId"
            :disabled="disabledFields.categoryId"
          >
            <option value="" v-if="Categories.length === 0" disabled>Carregando...</option>
            <option value="" v-else disabled>Selecione uma opção</option>
            <option
              v-for="(cat, index) in Categories"
              :key="index"
              :value="cat.id"
            >
              {{cat[`name_${DefaultLanguage || $route.query.lang}`]}}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="field has-text-centered">
      <button
        class="button is-primary is-large"
        @click="onSubmit(fData)"
        :class="{ 'is-loading': isLoading }"
        :disabled="isDisabled || $v.fData.$invalid"
      >
        {{ButtonLabel || "Cadastrar"}}
      </button>
    </div>
  </div>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
import FormMixin from './FormMixin'
import CharCount from '../CharCount'
import { GetAddressData } from '../../api/gmaps'

export default {
  name: 'PlaceForm',
  mixins: [FormMixin],
  components: { CharCount },
  data () {
    return {
      isSearchingLocation: false,
      fData: {
        name: '',
        active: true,
        shortDescription: '',
        longDescription: '',
        informations: '',
        operation: '',
        contacts: '',
        site: '',
        addressLatitude: -15.7989624,
        addressLongitude: -47.8884666,
        addressFormatted: '',
        categoryId: ''
      }
    }
  },
  validations: {
    fData: {
      name: {
        required
      },
      shortDescription: {
        required,
        maxLength: maxLength(500)
      },
      longDescription: {
        required,
        maxLength: maxLength(1000)
      },
      informations: {
        required,
        maxLength: maxLength(1000)
      },
      operation: {
        maxLength: maxLength(500)
      },
      contacts: {
        maxLength: maxLength(400)
      },
      site: {
        maxLength: maxLength(400)
      },
      addressLatitude: {
        required
      },
      addressLongitude: {
        required
      },
      addressFormatted: {
        required
      },
      categoryId: {
        required
      }
    }
  },
  computed: {
    ...mapGetters(['Categories', 'DefaultLanguage'])
  },
  methods: {
    getNewLatLng (data) {
      this.fData.addressLatitude = data.latLng.lat()
      this.fData.addressLongitude = data.latLng.lng()
    },
    searchLocation () {
      this.isSearchingLocation = true
      GetAddressData(this.fData.addressFormatted)
        .then(
          success => {
            if (success.data.results.length > 0) {
              this.fData.addressLatitude = success.data.results[0].geometry.location.lat
              this.fData.addressLongitude = success.data.results[0].geometry.location.lng
            }
            this.isSearchingLocation = false
          },
          error => {
            console.log(error.response)
            this.isSearchingLocation = false
            this.$notify.open({
              type: 'warning',
              content: 'Não foi possível localizar este endereço. Experimente outro endereço ou mova o marcador para a posição desejada.',
              duration: 10000
            })
          }
        )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/PlaceForm.vue